import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import CartItem from '../../components/cart/CartItem';
import CartSummary from '../../components/cart/CartSummary';
import EmptyCart from '../../components/cart/EmptyCart';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Button from '../../components/common/Button';
import { useCart } from '../../hooks/useCart';
import { theme } from '../../config/theme';
import { ArrowLeftIcon } from '../../components/icons/Icons';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const Cart = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { 
    items, 
    summary, 
    loading, 
    fetchCart,
    updateQuantity, 
    removeFromCart, 
    clearCart 
  } = useCart();

  // Fetch cart on mount
  useEffect(() => {
    fetchCart().catch(err => {
      console.error('Failed to load cart:', err);
    });
  }, [fetchCart]);

  if (loading && items.length === 0) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <MainLayout>
      <div style={{ padding: isMobile ? theme.spacing.md : theme.spacing.xl, maxWidth: '1200px', margin: '0 auto' }}>
        <Button 
          variant="ghost"
          size="md"
          onClick={() => navigate('/products')}
          style={{ marginBottom: theme.spacing.lg }}
        >
          <ArrowLeftIcon size={18} />
          Continue Shopping
        </Button>

        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold,
          marginBottom: theme.spacing.xl,
        }}>
          Shopping Cart
        </h1>

        {items.length === 0 ? (
          <EmptyCart />
        ) : (
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: isMobile ? '1fr' : '1fr 400px', 
            gap: isMobile ? theme.spacing.lg : theme.spacing.xl,
          }}>
            <div>
              {items.map(item => (
                <CartItem
                  key={item.id}
                  item={item}
                  onUpdateQuantity={updateQuantity}
                  onRemove={removeFromCart}
                  loading={loading}
                />
              ))}
            </div>

            <div style={{ position: 'sticky', top: theme.spacing.xl, height: 'fit-content' }}>
              <CartSummary 
                summary={summary}
                onClearCart={clearCart}
                loading={loading}
              />
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default Cart;